// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"57951de8","488":"a295b0dd","551":"e56d7566"}[chunkId] + ".chunk.js";
};